import React, { FC } from 'react'
import * as LocalStyles from './styles'
import ModalTemplate from '../../../../../uiKit/ModalTemplate'
import styles from '../../Abbreviations/fileUploadModal/styles.module.scss'
import * as Styles from '../../Abbreviations/styles'
import { CancelButton } from '../../Abbreviations/styles'
import { SparklesIcon } from '../../../../../uiKit/icons/SparklesIcon'
import { useKeyOnChange, useModalToggle } from '../hooks'
import { ExampleTemplateContainer } from './exampleTempate'
import { QuestionUploadForm } from './uploadForm'
import { useUnknownQuestions } from '../context'

type ImportQuestionsModalProps = {
  questionTypes: string[]
}

const Component: FC<{
  questionTypes: string[]
  isOpen: boolean
  toggleModal: () => void
  onImportComplete: () => void
}> = ({ isOpen, toggleModal, questionTypes, onImportComplete }) => {
  return (
    <>
      <LocalStyles.ImportIconButton onClick={toggleModal}>
        <LocalStyles.ImportIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 24">
          <path d="M8.88026 7.90294C8.37928 7.90294 7.96671 8.31941 7.96671 8.80529L7.96671 18.7906L8.04529 20.268L7.43626 19.5442L6.05121 18.0568C5.89404 17.8783 5.66811 17.7891 5.44218 17.7891C5.00014 17.7891 4.63669 18.1163 4.63669 18.5823C4.63669 18.8203 4.7251 18.9988 4.89209 19.1674L8.19264 22.3702C8.41857 22.6082 8.63468 22.6875 8.88026 22.6875C9.11601 22.6875 9.33212 22.6082 9.55805 22.3702L12.8586 19.1674C13.0256 18.9988 13.1238 18.8203 13.1238 18.5823C13.1238 18.1163 12.7604 17.7891 12.3183 17.7891C12.0924 17.7891 11.8566 17.8783 11.6995 18.0568L10.3242 19.5442L9.70539 20.268L9.78398 18.7906L9.78398 8.80529C9.78398 8.31941 9.37141 7.90294 8.88026 7.90294ZM14.5285 0L3.22217 0C1.10038 0 0.000200272 1.10066 0.000200272 3.21274L0.000200272 12.9799C0.000200272 15.0919 1.10038 16.1926 3.22217 16.1926H5.88422L5.88422 14.2491H3.34004C2.43632 14.2491 1.92552 13.7731 1.92552 12.8113V3.38131C1.92552 2.41947 2.43632 1.94351 3.34004 1.94351H14.4106C15.3242 1.94351 15.8252 2.41947 15.8252 3.38131V12.8113C15.8252 13.7731 15.3242 14.2491 14.4106 14.2491H11.8468V16.1926H14.5285C16.6503 16.1926 17.7505 15.0919 17.7505 12.9799L17.7505 3.21274C17.7505 1.10066 16.6503 0 14.5285 0Z" />
        </LocalStyles.ImportIcon>
      </LocalStyles.ImportIconButton>
      <ModalTemplate
        containerClasses={styles.modal}
        open={isOpen}
        title="Upload questions from file"
        titleIcon={
          <Styles.TitleIconWrapper>
            <SparklesIcon />
          </Styles.TitleIconWrapper>
        }
        onClose={toggleModal}
        withFooter={false}>
        <Styles.ModalContainer>
          <Styles.SubHeader>Please download example template and fill it with desired questions.</Styles.SubHeader>
          <Styles.SubHeader>
            Note: Provided example of questions from a document will be added as well, erase it if it's not necessary
            for inclusion.
          </Styles.SubHeader>
          <ExampleTemplateContainer questionTypes={questionTypes} />

          <QuestionUploadForm onImportComplete={onImportComplete} />
          <Styles.ModalButtonContainer>
            <CancelButton onClick={toggleModal}>Cancel</CancelButton>
          </Styles.ModalButtonContainer>
        </Styles.ModalContainer>
      </ModalTemplate>
    </>
  )
}

export const ImportQuestionsModal: FC<ImportQuestionsModalProps> = ({ questionTypes }) => {
  const { isOpen, toggleModal } = useModalToggle()
  const { searchQuestions } = useUnknownQuestions()

  const handleImportComplete = async () => {
    toggleModal()
    await searchQuestions()
  }

  const key = useKeyOnChange(isOpen)

  return <Component {...{ isOpen, toggleModal, key, questionTypes, onImportComplete: handleImportComplete }} />
}
